import MUILoadingButton from '@mui/lab/LoadingButton';
import PropTypes from 'prop-types';
import React from 'react';

const LoadingButton = React.forwardRef(
  (
    {
      children,
      variant,
      color,
      'data-test-subject': dataTestSubject,
      ...props
    },
    ref
  ) => {
    return (
      <MUILoadingButton
        ref={ref}
        data-test-subject={
          dataTestSubject ||
          (typeof children === 'string' ? `${children}-loading-button` : null)
        }
        variant={variant}
        color={color}
        {...props}>
        {children}
      </MUILoadingButton>
    );
  }
);

LoadingButton.displayName = 'LoadingButton';

LoadingButton.propTypes = {
  /** Displayed content. */
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
  /** Cypress hook. */
  'data-test-subject': PropTypes.string,
  variant: PropTypes.oneOfType([
    PropTypes.oneOf(['contained', 'outlined', 'text']),
    PropTypes.string,
  ]),
};

LoadingButton.defaultProps = {
  'data-test-subject': null,
  variant: 'contained',
  color: 'secondary',
};

export default LoadingButton;
